import { render, staticRenderFns } from "./VeJwCjPutin.vue?vue&type=template&id=ac23971e&scoped=true"
import script from "./VeJwCjPutin.vue?vue&type=script&lang=js"
export * from "./VeJwCjPutin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac23971e",
  null
  
)

export default component.exports